<template>
  <div class="aspect-ratio-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Continue with' | trans }}</div>
      <div class="text-muted font-weight-bold"></div>
    </div>
    <div class="continue-btn-box">
      <div class="continue-btn" v-bind:class="{ 'disabled': complete !== true}" @click="openContinue('aiupscaleimage')">
        <div class="continue-btn-text">
          <i class="far fa-eye"></i> {{ 'Upscale' | trans }}
        </div>
        <div><i class="far fa-arrow-right"></i></div>
      </div>
      <div class="continue-btn" v-bind:class="{ 'disabled': complete !== true}" @click="openContinue('edit')">
        <div class="continue-btn-text">
          <i class="far fa-edit"></i> {{ 'Edit' | trans }}
        </div>
        <div><i class="far fa-arrow-right"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";

export default {
  name: "ContinueWith",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openContinue(operation) {
      if (this.complete) {
        JobManager.openOperation(this.id, operation)
      }
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.continue-btn-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.disabled {
  opacity: .5;
  cursor: not-allowed !important;
}

.continue-btn {
  display: flex;
  background: #383838;
  border: 1px solid #595959;
  border-radius: 4px;
  justify-content: space-between;
  padding: 10px 20px !important;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #323232;
  }

  .continue-btn-text {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}
</style>
